import styled from 'styled-components';
import { Textarea } from 'react-rainbow-components';
import ButtonIcon from 'components/ButtonIcon';
import { color } from 'theme';
import { DIVIDER, GREY_400, WHITE } from '../../../constants';

export const ModalContent = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1rem;
    padding: 0.25rem 0 0;
`;

export const FieldContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-self: stretch;
    width: 100%;
    box-sizing: border-box;
`;

export const FieldLabel = styled.span`
    margin-bottom: 0.25rem;
    color: ${GREY_400};
    font-size: 0.75rem;
    font-weight: 400;
    line-height: 1.375rem;
`;

export const RequiredMark = styled.abbr`
    margin-left: 0.125rem;
    color: ${color('error.main')};
    text-decoration: none;
`;

export const InputWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-self: stretch;
    width: 100%;
    box-sizing: border-box;
    overflow: hidden;
    border: 1px solid ${DIVIDER};
    border-radius: 0.375rem;
    background: ${WHITE};
`;

export const ReasonField = styled(Textarea)`
    display: flex;
    align-self: stretch;
    width: 100%;
    box-sizing: border-box;

    label {
        display: none;
    }

    > div {
        border: none;
        box-shadow: none;
        box-sizing: border-box;
        background: ${WHITE};
    }

    textarea {
        width: 100%;
        box-sizing: border-box;
        border: none;
        border-radius: 0;
        padding: 0.5rem 0.875rem;

        &:focus,
        &:active {
            width: 100%;
            padding: 0.5rem 0.875rem;
            border: none;
            box-shadow: none;
        }

        &::placeholder {
            font-weight: 300 !important;
        }
    }

    div[id^="error-message"] {
        align-self: flex-start;
        padding: 0 0.875rem 0.5rem;
    }
`;

export const ActionsContainer = styled.div`
    display: flex;
    position: relative;
    align-items: flex-start;
    align-self: stretch;
    padding: 0.25rem 0.875rem;

    &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0.875rem;
        right: 0.875rem;
        border-top: 1px solid ${DIVIDER};
    }
`;

export const ActionButton = styled(ButtonIcon)`
    width: 3rem;
    height: 3rem;

    svg {
        width: 1.5rem !important;
        height: 1.5rem !important;
        font-size: 1.5rem !important;
    }
`;

export const DictateFormContainer = styled(InputWrapper)`
    padding: 0.5rem 0.875rem;

    & > div {
        margin: 0;
        border: none;
        border-radius: 0;
    }
`;

export const ButtonsContainer = styled.div`
    display: flex;
    justify-content: flex-end;
    padding: 4px 0 0;
`;
